function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  className: "mentor1",
  cx: 52.56,
  cy: 62.37,
  r: 41.93,
  fill: "#bfe6e5"
});

var SvgIcon2 = function SvgIcon2(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 115 115",
    ref: svgRef
  }, props), React.createElement("g", {
    "data-name": "Layer 1"
  }, _ref2, React.createElement("circle", {
    className: "mentor2",
    cx: 79.11,
    cy: 36.25,
    r: 26.25,
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#33c100"
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcon2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Icon_2.ea3aad17.svg";
export { ForwardRef as ReactComponent };